import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=8ed5489e&scoped=true&"
import script from "./LinkCard.vue?vue&type=script&lang=js&"
export * from "./LinkCard.vue?vue&type=script&lang=js&"
import style0 from "./LinkCard.vue?vue&type=style&index=0&id=8ed5489e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed5489e",
  null
  
)

export default component.exports